import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/web/src/app/(networks)/(evm)/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SanctionedAddressDialog"] */ "/vercel/path0/apps/web/src/lib/wagmi/components/sanctioned-address-dialog.tsx");
